import { render, staticRenderFns } from "./AgeBanner.vue?vue&type=template&id=3e0cba3d&scoped=true"
import script from "./AgeBanner.vue?vue&type=script&lang=js"
export * from "./AgeBanner.vue?vue&type=script&lang=js"
import style0 from "./AgeBanner.vue?vue&type=style&index=0&id=3e0cba3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0cba3d",
  null
  
)

export default component.exports